import {
  BlockVariation,
  InnerBlockTemplate,
  registerBlockVariation,
} from "@wordpress/blocks";
import { IconType, SVG, Path } from "@wordpress/components";
import React from "react";
import config, { type BlockAttributes } from "./block.json";

function makeIcon(columns: number[]) {
  const splits: { left: number; width: number; solid: boolean }[] = [];
  for (const col of columns) {
    const lastSplit = splits.at(-1) ?? { left: 0, width: 0, solid: false };
    const left = lastSplit.left + lastSplit.width;
    if (left >= 12) {
      break;
    }
    splits.push({
      left,
      width: Math.abs(col),
      solid: col < 0,
    });
  }
  const size = 64;
  const columnWidth = 4;
  const left = Math.round((size - 12 * columnWidth) / 2);
  const iconHeight = Math.round((12 * columnWidth) / 1.618);
  const top = Math.round((size - iconHeight) / 2);
  const bottom = iconHeight + top;
  return (
    <SVG
      viewBox={[0, 0, size, size].join(" ")}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={left}
        y={top}
        width={columnWidth * 12}
        height={iconHeight}
        rx="2"
        stroke="currentColor"
        fill="transparent"
        strokeWidth={4}
      />
      {splits.map(({ left: l, solid, width: w }, i) => {
        if (i > 0 && !solid && splits[i - 1]?.solid) {
          return null;
        }
        const x = left + columnWidth * l;
        return solid ? (
          <rect
            x={x}
            y={top}
            width={columnWidth * w}
            height={bottom - top}
            stroke="currentColor"
            fill="currentColor"
            strokeWidth={4}
            key={l}
          />
        ) : (
          <line
            stroke="currentColor"
            fill="transparent"
            x1={x}
            y1={top}
            x2={x}
            y2={bottom}
            strokeWidth={4}
            key={l}
          />
        );
      })}
    </SVG>
  );
}

const variations: (BlockVariation<BlockAttributes> & {
  innerBlocks: InnerBlockTemplate[];
})[] = [
  {
    name: "1",
    title: "Abschnitt",
    icon: makeIcon([]),
    innerBlocks: [["yellowtree/column", {}]],
    isDefault: true,
  },
  {
    name: "1-1",
    title: "2 Spalten (1:1)",
    icon: makeIcon([6, 6]),
    innerBlocks: [
      ["yellowtree/column", { xl: 6 }],
      ["yellowtree/column", { xl: 6 }],
    ],
    isDefault: true,
  },
  {
    name: "70-30",
    title: "2 Spalten (70:30)",
    icon: makeIcon([7, 5]),
    innerBlocks: [
      ["yellowtree/column", { xl: 7, offsetMd: 0 }],
      ["yellowtree/column", { xl: 5, offsetXl: 0 }],
    ],
  },
  {
    name: "30-70",
    title: "2 Spalten (30:70)",
    icon: makeIcon([5, 7]),
    innerBlocks: [
      ["yellowtree/column", { xl: 5, offsetXl: 0 }],
      ["yellowtree/column", { xl: 7, offsetXl: 0 }],
    ],
  },
  {
    name: "80-20",
    title: "2 Spalten (80:20)",
    icon: makeIcon([8, 4]),
    innerBlocks: [
      ["yellowtree/column", { xl: 8, offsetMd: 0 }],
      ["yellowtree/column", { xl: 4, offsetXl: 0 }],
    ],
  },
  {
    name: "20-80",
    title: "2 Spalten (20:80)",
    icon: makeIcon([4, 8]),
    innerBlocks: [
      ["yellowtree/column", { xl: 4, offsetXl: 0 }],
      ["yellowtree/column", { xl: 8, offsetXl: 0 }],
    ],
  },
  {
    name: "1-1-1",
    title: "3 Spalten (1:1:1)",
    icon: makeIcon([4, 4, 4]),
    innerBlocks: [
      ["yellowtree/column", { xl: 4 }],
      ["yellowtree/column", { xl: 4 }],
      ["yellowtree/column", { xl: 4 }],
    ],
  },
  {
    name: "10-90",
    title: "2 Spalten (10:90)",
    icon: makeIcon([3, 9]),
    innerBlocks: [
      ["yellowtree/column", { xl: 3 }],
      ["yellowtree/column", { xl: 9 }],
    ],
  },
];

export function registerBlockVariations() {
  for (const variation of variations) {
    registerBlockVariation(config.name, {
      ...variation,
      title:
        variation.innerBlocks.length > 1
          ? `Mehrspalter: ${variation.title}`
          : variation.title,
      scope: ["inserter", "block", "transform"],
      attributes: { template: variation.name },
      isActive: ["template"],
    });
  }
}

export default variations;
